<div>
  <img src="{{ assetsPath + 'waiting.svg' }}" alt="sand clock" />
  <p class="body2--bold">{{ 'LAST_CATEGORY.EMPTY' | translate }}</p>
</div>
